import React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from 'reactstrap';

import { useStore } from '../stores/store';

const ModalContainer = () => {
  const { open, body } = useStore().modalStore.modal;

  return (
    <Modal autoFocus={false} isOpen={open}>
      {body}
    </Modal>
  );
};

export default observer(ModalContainer);
